import { jsx as _jsx } from "react/jsx-runtime";
import { InlineNotification, useLocalizeMessage } from 'libs.nucleus';
export const TranslationsOutOfSyncBanner = () => {
    const t = useLocalizeMessage();
    return (_jsx(InlineNotification, { title: t('Translations are out of sync'), subtitle: t('Some translations differ from the source language. Please check and update the translations accordingly.') }));
};
